import * as React from "react"
import { JSX } from "react/jsx-runtime"

export function BookOen(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={42}
      height={42}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 10.942v22.75m0-22.75c-2.044-1.357-4.819-2.192-7.875-2.192s-5.831.835-7.875 2.192v22.75c2.044-1.358 4.819-2.192 7.875-2.192s5.831.834 7.875 2.192m0-22.75c2.044-1.357 4.819-2.192 7.875-2.192s5.831.835 7.875 2.192v22.75c-2.044-1.358-4.819-2.192-7.875-2.192s-5.831.834-7.875 2.192"
        stroke={props.color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
